<script setup>
import { ref } from 'vue'
import { getI18n, getTranslatedField } from '@/plugins/i18n'

import * as dataGrid from '@/composables/data-grid'
import { useDefaultDialogTitle } from '@/composables/data-grid'

import { DxDataGrid } from 'devextreme-vue'

import { useGarageStore } from '@/stores/garage.store'

const props = defineProps({
  readOnly: { type: Boolean }
})

const gridId = 'intervention-type-grid'
const gridRef = ref(null)
const i18n = getI18n()

const garageStore = useGarageStore()

const columns = [
  { dataField: 'code', caption: i18n.t('common.code'), validationRules: [{ type: 'required' }] },
  {
    dataField: 'name',
    caption: i18n.t('common.name'),
    calculateCellValue: (rowData) => getTranslatedField(rowData, 'name'),
    validationRules: [{ type: 'required' }]
  },
  {
    dataField: 'color',
    caption: i18n.t('common.color'),
    cellTemplate: 'colorCellTemplate',
    validationRules: [{ type: 'required' }]
  },
]

const {defaultDialogTitle} = useDefaultDialogTitle()
const editing = dataGrid.useDefaultEditing(i => defaultDialogTitle(i, i18n.t('common.interventionType')), {
  itemType: 'group',
  colCount: 1,
  items: [
    {
      itemType: 'group',
      colCount: 2,
      items: [
        { dataField: 'code', editorOptions: { readOnly: true } },
        { dataField: 'name', editorOptions: { readOnly: true } },
        { dataField: 'color', editorType: 'dxColorBox' },
      ]
    }
  ]
}, {
  allowAdding: false,
  allowUpdating: !props.readOnly,
  allowDeleting: false,
})

const dataSource = dataGrid.useODataSource(garageStore.api.getAbsoluteUrl() + garageStore.api.interventionTypesUrl)
const gridOptions = dataGrid.useDefaultGridOptions({
  id: gridId,
  dataSource: dataSource,
  columns: columns,
  editing: editing,
  columnChooser: { enabled: false },
  filterRow: { visible: !props.readOnly },
  height: '100%',
})
</script>
<template>
  <dx-data-grid
    ref="gridRef"
    v-bind="gridOptions"
  >
    <template #colorCellTemplate="{ data }">
      <div style="display: flex; align-items: center; gap: 8px;">
        <div
          :style="{
            width: '16px',
            height: '16px',
            backgroundColor: data.data.color,
            border: '1px solid #ccc',
          }"
        />
        <span>{{ data.data.color }}</span>
      </div>
    </template>
  </dx-data-grid>
</template>
